<!-- @format -->

<toasts>
  <style>
    /* prettier-ignore */
    @keyframes slide-in-out {
      0%   { right: -120%; }
      10%  { right:    0%; }
      90%  { right:    0%; }
      100% { right: -120%; }
    }
    .toast {
      padding: 0.5em 1em;
      margin: 0.5em 0;
      position: relative;
      right: -120%;
      display: inline-block;
      animation: slide-in-out var(--lifespan) ease;
      font-size: 1.7rem;
      font-weight: bold;
      letter-spacing: 0.1em;
    }
    .toasts-container {
      text-align: right;
      position: fixed;
      right: 16px;
      bottom: 16px;
      z-index: 10001;
      transform: translateX(0);
      transition-property: transform;
      transition-duration: 0.5s;
    }
    .toasts-container.out {
      transform: translateX(120%);
    }
    .negative {
      background-color: #e6c3c2;
      color: #a95a59;
      box-shadow: 0 0 0 3px #a95a59 inset, 0 0 0 0 transparent;
    }
    .success {
      background-color: #dce6d3;
      color: #6b8e67;
      box-shadow: 0 0 0 3px #6b8e67 inset, 0 0 0 0 transparent;
    }
  </style>

  <div
    class="toasts-container { fade }"
    style="--lifespan: { getLifespan() }ms"
    onclick="{ onClick }"
  >
    <div each="{ mes in list }" id="toast-{ mes.num }">
      <div class="{ mes.color } toast">{ mes.message }</div>
    </div>
  </div>

  <script>
    import di from "dependency-injection";

    export default {
      fade: "",
      list: [],
      onBeforeMount(props, states) {
        di.set(props.diRegisterName ? props.diRegisterName : "toast", this);
      },
      getLifespan() {
        return Number(this.props.lifespan ? this.props.lifespan : 5000);
      },
      push(message, color) {
        this.lasttime = new Date().getTime();

        const num = this.list.length;
        this.list.push({
          message,
          color,
          num,
        });
        this.update();

        setTimeout(() => {
          if (
            this.$(`#toast-${num}`) &&
            this.lasttime + this.getLifespan() < +new Date().getTime()
          ) {
            this.onClick();
          }
        }, this.getLifespan());
      },
      onClick(e) {
        this.fade = "out";
        this.update();
        setTimeout(
          () => {
            this.fade = "";
            this.list = [];
            this.update();
          },
          e ? 500 : 0
        );
      },
    };
  </script>
</toasts>
